// This takes an object and turns it into an array of labels and values for <selects>
// Example of input : {779: "Walden Commons", 224: "Test Neighborhood"}
export default function transformOptions(opts) {
	var ret = []
	Object.keys(opts).forEach(function(key, index) {
		// key: the name of the object key
		// index: the ordinal position of the key within the object
		ret.push({ label: opts[key], value:key })
	})

	return ret
}